module.exports = __webpack_public_path__ + "static/media/integral-logo.01b98a0c.png";